import { render, staticRenderFns } from "./forbidden-to-change-plan.vue?vue&type=template&id=4aa94826&scoped=true&"
import script from "./forbidden-to-change-plan.vue?vue&type=script&lang=ts&"
export * from "./forbidden-to-change-plan.vue?vue&type=script&lang=ts&"
import style0 from "./forbidden-to-change-plan.vue?vue&type=style&index=0&id=4aa94826&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa94826",
  null
  
)

export default component.exports